import styled from 'styled-components';

export const Highlighter = styled.div`
  &:focus {
    outline: none;
    background-color: var(--cl-yellow-200);
  }
`;
